import type { ComponentType } from "react";
import type { ListDeleteModalProps } from "../../components/modals/ListDeleteModal/ListDeleteModal";
import trackingService from "../../services/tracking/trackingService";

type ExpectedProps = Partial<Pick<ListDeleteModalProps, "onCancel" | "onSubmit">>;

/**
 * This HoC incapsulates tracking for "cancel" & "submit" actions
 * @param DeleteModalComponent
 */
export default function withListDeleteModalTracking<P extends ExpectedProps>(DeleteModalComponent: ComponentType<P>) {
    return function WrappedWithListDeleteTracking(props: P) {
        function handleCancel() {
            trackingService.trackListDeleteCancelClicked();
            props.onCancel?.();
        }

        function handleSubmit(name: string) {
            trackingService.trackListDeleteSubmitClicked();
            props.onSubmit?.(name);
        }

        return (
            <DeleteModalComponent
                {...props}
                onCancel={handleCancel}
                onSubmit={handleSubmit}
            />
        );
    };
}
